import * as React from 'react'
import ReactPixel from 'react-facebook-pixel'
import { useLocation } from 'react-router-dom'

import { Loading } from '@factorialco/deprecated-design-system'
import { EnvironmentContext } from 'config/environment'
import {
  CanSeeMarketplaceRevampDocument,
  CanSeeModulesMarketplaceDocument,
} from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import List from 'modules/marketplace_modules/components/Revamp/List'

const ModulesPage = () => {
  const environment = React.useContext(EnvironmentContext)
  const location = useLocation()
  const upsellOrigin = new URLSearchParams(location.search).get('upsell_origin')
  const { data: policies } = useQuery(CanSeeModulesMarketplaceDocument)
  const isAuthorized = policies?.modules._policies.moduleManageModule.can
  const { data: isRevampEnabled, loading: isRevampEnabledLoading } = useQuery(
    CanSeeMarketplaceRevampDocument
  )
  const isAuthorizedRevamp =
    isRevampEnabled?.modules._policies.marketplaceRevampSeeMarketplaceRevamp.can

  const { facebookPixelEnabled } = environment
  useEffect(() => {
    track(trackingEvents.marketplaceModules.visitModulesPage, {
      upsell_origin: upsellOrigin,
    })
    facebookPixelEnabled &&
      ReactPixel.trackCustom('ViewAdminOnlyPage', { page: 'MarketplaceModulesPage' })
  }, [facebookPixelEnabled, upsellOrigin])

  if (isRevampEnabledLoading) {
    return <Loading />
  }

  return (
    <ResponsivePage.Body authorized={isAuthorized || isAuthorizedRevamp}>
      <List />
    </ResponsivePage.Body>
  )
}

export default ModulesPage
